import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-44eaa970"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "menu"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "box"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card"
}, [/*#__PURE__*/_createElementVNode("h3", null, "歌曲列表")], -1));
const _hoisted_5 = {
  class: "card",
  style: {
    "height": "453px",
    "overflow": "auto"
  }
};
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<table class=\"table\" style=\"margin-top:10px;\" data-v-44eaa970><tr class=\"title\" data-v-44eaa970><td style=\"width:8%;\" data-v-44eaa970>序号</td><td style=\"width:15%;\" data-v-44eaa970>歌名</td><td style=\"width:12%;\" data-v-44eaa970>歌手</td><td style=\"width:20%;\" data-v-44eaa970>播放时间</td><td data-v-44eaa970>歌曲id</td><td style=\"width:8%;\" data-v-44eaa970>歌曲资费</td><td style=\"width:15%;\" data-v-44eaa970>订单状态</td><td style=\"width:10%;\" data-v-44eaa970>操作</td></tr></table>", 1);
const _hoisted_7 = {
  key: 0,
  class: "table"
};
const _hoisted_8 = {
  style: {
    "width": "8%"
  }
};
const _hoisted_9 = {
  style: {
    "width": "15%"
  }
};
const _hoisted_10 = {
  style: {
    "width": "12%"
  }
};
const _hoisted_11 = {
  style: {
    "width": "20%"
  }
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  style: {
    "width": "8%"
  }
}, "1", -1));
const _hoisted_13 = {
  style: {
    "width": "15%"
  }
};
const _hoisted_14 = {
  style: {
    "width": "10%"
  }
};
const _hoisted_15 = {
  key: 1,
  style: {
    "padding": "100px 0"
  }
};
import { showFailToast, showSuccessToast } from "vant";
import { reactive, onMounted } from 'vue';
import moment from "moment";
import Menu from "@/components/menu.vue";
import api from "@/api";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const data = reactive({
      userId: '',
      orderId: '',
      songList: []
    });
    onMounted(async () => {
      var _JSON$parse;
      const User = window.localStorage.getItem('user');
      data.userId = (_JSON$parse = JSON.parse(User)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.id;
      await api.playList(data.userId).then(res => {
        if (res.data.code == 0) {
          data.songList = res.data.data;
        }
      });
    });
    const refund = async e => {
      data.orderId = e;
      if (!data.orderId) return;
      await api.songRefund(data.userId, data.orderId).then(res => {
        if (res.data.code == 0) {
          showSuccessToast('退款成功');
          setTimeout(() => {
            location.reload();
          }, 1500);
        } else {
          showFailToast(res.data.msg);
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Menu, {
        "active-name": ""
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, data.songList && data.songList.length > 0 ? (_openBlock(), _createElementBlock("table", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.songList, (item, index) => {
        return _openBlock(), _createElementBlock("tr", {
          class: "songList",
          key: index
        }, [_createElementVNode("td", _hoisted_8, _toDisplayString(index + 1), 1), _createElementVNode("td", _hoisted_9, _toDisplayString(item.song.songname), 1), _createElementVNode("td", _hoisted_10, _toDisplayString(item.song.singer), 1), _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(moment)(item.createTime).format('YYYY-MM-DD HH:mm:ss')), 1), _createElementVNode("td", null, _toDisplayString(item.song.id), 1), _hoisted_12, _createElementVNode("td", _hoisted_13, _toDisplayString(item.orderState == 0 ? '已支付' : '已退费'), 1), _createElementVNode("td", _hoisted_14, [item.orderState == 0 ? (_openBlock(), _createBlock(_component_van_button, {
          key: 0,
          type: "primary",
          size: "small",
          onClick: $event => refund(item.song.id)
        }, {
          default: _withCtx(() => [_createTextVNode("退款")]),
          _: 2
        }, 1032, ["onClick"])) : (_openBlock(), _createBlock(_component_van_button, {
          key: 1,
          type: "success",
          disabled: "",
          size: "small"
        }, {
          default: _withCtx(() => [_createTextVNode("成功")]),
          _: 1
        }))])]);
      }), 128))])) : (_openBlock(), _createElementBlock("p", _hoisted_15, "暂无数据"))])])])]);
    };
  }
});